import styled from 'styled-components';

interface Props {
  $position?: string;
}

export default styled.div<Props>`
`;
